<template>
  <div class="flex items-center justify-between top-block">
    <a href="/" class="flex">
      <img
        src="https://s3.amazonaws.com/ma-content/images/2024/logo-light.png"
        alt="Motion Array"
        title="Motion Array"
        style="max-width:130px;"
      />
    </a>

    <a
      v-if="isLoggedIn"
      href="/account/"
      class="drawer-link ml-auto mr-3 grey-btn"
    >
      <i class="fas fa-user-circle" />
    </a>
    <button
      type="button"
      class="grey-btn"
      @click="onToggleMenu"
    >
      <i class="fas fa-times" v-if="this.drawerOpen" />
      <i class="fas fa-bars" v-if="!this.drawerOpen" />
    </button>
  </div>
</template>

<style scoped>
.grey-btn {
  width: 15px;
  line-height: 1.2;
  font-size: 16px;
  padding: 0;
  @apply text-primary-light-purple;
}
</style>

<script>
export default {
  props: {
    drawerOpen: {
      type: Boolean,
      default: true,
    },

    drawerToggled: {
      type: Function,
      default: () => {},
    },
  },

  computed: {
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },
  },

  methods: {
    onToggleMenu() {
      this.$emit('drawerToggled');
    },
  }
}
</script>
